import ReactTooltip from "react-tooltip";
import { ChipInputProps } from "../../types";
import HelpIcon from "../../assets/icons/help-circle.svg";
import {
  ChipInputRoot,
  ErrorInputText,
  InputBoxWithChip,
  InputForChip,
  Label,
} from "./InputBox.styles";
import Chip from "../chip/Chip";
import ChipImage from "./ChipImage";

function ChipInput(props: ChipInputProps) {
  const { chips, onStrokeEnterKey } = props;

  const {
    id,
    labelName,
    placeHolderName,
    value,
    handler,
    error,
    style,
    showTooltip = false,
    onCloseChip,
    toolTipMessage,
  } = props;

  return (
    <ChipInputRoot style={{ ...style }}>
      <Label error={Boolean(error)} htmlFor={id}>
        {labelName}
        {showTooltip && (
          <ChipImage
            styles={{ verticalAlign: "middle", paddingLeft: "8px" }}
            icon={HelpIcon}
            alt="help-icon"
            id={id}
          />
        )}
        {showTooltip && (
          <ReactTooltip
            id={id}
            place="bottom"
            effect="solid"
            className="tooltip-custom"
            backgroundColor={"#636C79"}
            offset={{ left: -5 }}
          >
            {toolTipMessage}
          </ReactTooltip>
        )}
      </Label>

      <InputBoxWithChip error={Boolean(error)}>
        {chips?.map((chip, idx) => (
          <Chip
            chip={chip}
            key={idx}
            onCloseChip={(e: React.SyntheticEvent) => {
              e.stopPropagation();
              onCloseChip(chip);
            }}
          />
        ))}
        <InputForChip
          id={id}
          name={id}
          type={"text"}
          placeholder={chips.length > 0 ? "" : placeHolderName}
          value={value}
          onChange={(e) => handler(e)}
          onKeyPress={(e) => e.key === "Enter" && onStrokeEnterKey()}
        />
      </InputBoxWithChip>

      {error && <ErrorInputText>{`* ${error}`}</ErrorInputText>}
    </ChipInputRoot>
  );
}

export default ChipInput;
